export const placeData = {
	title: "Contract Information",
	description: "General account information",
	loading: "Loading...",
	accessDenied: {
		title: "Access Denied",
		description: "You do not have permission to access this screen.",
	},
	error: {
		title: "Error",
		description: "An error occurred while loading the data. Please try again.",
	},
	sections: {
		general: {
			title: "General",
			description: "General account information",
		},
		fees: {
			title: "Fees",
			description: "Values represent the fee that will be applied to the items below",
		},
		balanceModel: {
			title: "Balance model",
			description: "Balance return definition",
		},
		grabAndGo: {
			title: "Grab and Go",
			description: "Configured delivery type",
		},
		eventCurrency: {
			title: "Event currency",
			description: "Currency and proportion used",
		},
		smartPosSettings: {
			title: "SmartPOS settings",
			description: "Integration data",
		},
		communication: {
			title: "Communication",
			description: "Sending messages (SMS and WhatsApp)",
		},
	},
	fields: {
		contractNumber: "Contract number",
		profile: "Profile",
		mainVersion: "Main version",
		guaranteedMonthlyMinimum: "Guaranteed monthly minimum",
		monthlyBillingCap: "Monthly billing cap",
		zigResponsible: "ZIG Responsible",
		placeStatus: "Place status",
		ppuAuthorizationValue: "App pre-authorization amount",
		zigLocation: "Zig Location",
		rechargeNotIntegratedLimit: "Non-integrated recharge limit",
		localResponsible: "Local responsible(s)",
		minVersion: "Minimum PDV version",
		status: {
			active: "Active",
			blocked: "Blocked",
			inactive: "Inactive",
			paused: "Paused",
		},
		profileValues: {
			barAndRestaurant: "Bar and Restaurant",
			restaurant: "Restaurant",
			concertHall: "Concert Hall",
			bar: "Bar",
			nightclub: "Nightclub",
			park: "Park",
			sportsArena: "Sports Arena",
			other: "Other",
		},
		house: "House",
		nonIntegratedPaymentLimit: "Non-integrated payment limit per device and event",
		placeClassification: "Place classification",
		smsNumbers: "Numbers for sending revenue SMS",
		serviceFee: "Service fee",
		deliveryFee: "Delivery fee",
		onlineDeliveryFee: "Online delivery fee",
		advanceReservationFee: "Advance reservation fee",
		processingFee: "Processing fee",
		platformFee: "Platform fee",
		balanceReturnType: "Balance return type",
		parentPlaceName: "Parent Place",
		returnPeriod: "Return period",
		minimumBalance: "Minimum balance",
		maximumBalance: "Maximum balance",
		deliveryType: "Delivery type",
		deliveryTime: "Delivery time",
		deliveryRadius: "Delivery radius",
		deliveryTypes: {
			counterDelivery: "Counter delivery",
			tableDelivery: "Table delivery",
		},
		deliveryPlatforms: {
			ifood: {
				brandName: "IFood",
				settlementDays: "Days until IFood settlement",
				fee: "iFood fee",
				description: "IFood  Settings",
			},
		},
		currency: "Name",
		exchangeRate: "Proportion to the country's currency",
		currencySymbol: "Symbol",
		decimalPlaces: "Decimal places",
		integrationStatus: "Integration status",
		apiVersion: "API version",
		lastSync: "Last sync",
		syncFrequency: "Sync frequency",
		smsCost: "Cost of sending",
		whatsappCost: "Cost of sending",
		whatsappNumber: "Number",
		whatsappId: "Service ID",
		pushNotifications: "Push notifications",
		placeType: "Place Type",
		placeTypesValues: {
			default: "Default",
			delivery: "Delivery",
			transfers: "Transfers",
			advance: "Advance",
			billing: "Billing",
		},
		zigFeeShouldBeChargedInDebit: "Charge Zig fee on debit date",
		hasCustomizedCard: "Security deposit belongs to the customer",
		user: "User",
		fiscalPrinters: "Fiscal printers",
		name: "Printers",
		bankAccountData: "Bank account data",
		receivingAccount: "Receiving account",
		accountHolder: "Account holder",
		documentType: "Document type",
		digit: "Digit",
		accountIdentification: "Account identification",
		accountIdentifier: "Account identifier",
		cpfCnpj: "CPF/CNPJ",
		accountType: "Account type",
		accountTypes: {
			conta_corrente: "Checking",
			conta_poupanca: "Savings",
			conta_salario: "Salary",
		},
		registrationData: "Data to register",
		bankData: "Bank data",
		branch: "Branch",
		bank: "Bank",
		bankName: "Bank name",
		account: "Account",
		recharges: "Recharges",
		rechargeValidityCriteria: "Validity and recharge criteria",
		rechargesExpireIn: "Recharges expire in",
		remainingRechargeActions: "Actions for remaining recharge",
		delveryOnlineRules: "Online delivery rules",
		chargeBack: "Expire at the end of the event",
		placeOnly: "Managed by the house",
		normal: "Managed by Zig",
		// Rates and values
		rateType: "Type",
		rateTypeLabel: "Rate type",
		singleRate: "Single rate",
		segmentedFeeType: "Segmented fee",
		singleFeeType: "Single fee",
		systemFee: "System fee",
		inHouseConsumption: "In-house consumption",
		ticketOfficeRevenue: "Ticket office revenue",
		rechargeSurplus: "Recharge surplus",
		bonus: "Bonus",
		fixedFee: "Fixed fee",
		appFee: "App fee",
		prechargeOnlinePaymentFee: "Pre-charge/online payment fee",
		fixedFeePaymentDay: "Fixed fee payment day",
		anticipationFee: "Anticipation fee",
		thirdPartyPaymentFee: "Third-party payment fee",
		// Payment with ZigPay machine
		zigPayMachinePayment: "Payment with ZigPay machine",
		debit: "Debit",
		credit: "Credit",
		creditOtherFlags: "Credit (Other flags)",
		debitOtherFlags: "Debit (Other flags)",
		replicateRatesForAllFlags: "Replicate rates for all flags?",
		pix: "Pix",
		pixKey: "Pix Key",
		pixKeyType: "Pix Key Type",
		yes: "Yes",
		// Food voucher
		foodVoucher: "Food voucher",
		// Payment with machine integrated into client's EC
		integratedMachinePayment: "Payment with machine integrated into client's EC",
		machineCommission: "Machine commission",
		anticipatedConsumption: "Anticipated consumption",
		anticipatedBar: "Anticipated/Bar",
		ticketOffice: "Ticket office",
		// Days until collection
		daysUntilCollection: "Days until collection",
		daysUntilCollectionDescription:
			"Number of days to exercise collection and payments in the following formats",
		collectionDaysDescription:
			"Number of days to exercise collection and payments in the following formats",
		// Installments
		installment: "Installments",
		installmentFee: "Installment fee",
		maxInstallments: "Max number of installments",
		notApplicable: "Not applicable",
	},
};
